<template>
  <div class="bannerList" v-if="images && images.length>0">
    <van-swipe class="my-swipe" :autoplay="4000" indicator-color="#009ed4">
      <van-swipe-item v-for="(image, index) in images" :key="index" @click="openLink(image.LinkUrl)">
        <img class="swipeItem" :src="imgUrlFilter(image.ImgUrl)" />
      </van-swipe-item>
    </van-swipe>
  </div>
</template>
<script>
import { Swipe, SwipeItem } from "vant";
export default {
  name: "Banner",
  components: {
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
  },
  props: ["images"],
  data() {
    return {
      background: require("@/assets/img/slides/background.png"),
    };
  },
  methods: {
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    openLink(url) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.gotoPay, {
        url: url,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
.bannerList {
  background-image: url("~assets/img/slides/background.png");
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: 55.47vw;
  .my-swipe .van-swipe-item {
    width: 100%;
    .swipeItem {
      width: 100%;
      height: 55.47vw;
      object-fit: cover;
    }
  }
}
</style>
